module.exports = __webpack_public_path__ + "img/taiwan.e1fd0e46.svg";